import IconInfo from "@common/components/icons/IconInfo";
import WarningCard from "@common/components/thirdParty/mantine/WarningCard";
import { Flex, Text, useMantineTheme } from "@mantine/core";
import { ReactElement } from "react";
import { IMigrationCardProps } from "./types";

export default function MigrationCard({
  loggedIn,
  isValid,
}: IMigrationCardProps): ReactElement {
  const theme = useMantineTheme();

  return (
    <WarningCard>
      <Flex
        align="center"
        direction="row"
        justify="flex-start"
        wrap="nowrap"
        w="100%"
      >
        <IconInfo color={theme.colors.yellow[3]} size={16} />
        <Text c="gray.5" fw={700} fz="sm" ml="xs">
          {loggedIn ? "Migration process" : "Sign up to proceed with migration"}
        </Text>
      </Flex>

      {isValid ? (
        <Text fz="sm">
          {loggedIn
            ? "Once your instance is created, you will be redirected to the migration page where you will see its progress."
            : "Sign up for a Metabase account to continue your cloud migration."}
        </Text>
      ) : (
        <Text fz="sm">
          The migration id is invalid but you can still create a new instance...
        </Text>
      )}
    </WarningCard>
  );
}
